import { Modal, Form, Row, Col, Select, Input, Button, message } from "antd";
import { useState } from "react";
import { getFirestore, doc, updateDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { validateColor, validateQty, validatePrice } from "./validations";
import { checkCategory, checkValueFirebase, mapDocs, APP_VERSION } from "../../utils";
import { logUserAction } from "../../logs";

export const AddItem = ({ isOpen, setIsOpen, brands, categories, order, updateItems, updateOrder, itemsViewable }) => {

    const [form] = Form.useForm();
    const { Option } = Select;
    const { TextArea } = Input;
    const querydb = getFirestore();
    const auth = getAuth();

    const [sizes, setSizes] = useState();
    const productList = order.products;

    const handleSignUp = async (values) => {
        try {

            const newItem = {
                brand: values.brand.toUpperCase(),
                category: values.category.toUpperCase(),
                color: values.color.toUpperCase(),
                model: values.model.toUpperCase(),
                sku: values.model.toUpperCase(),
                size: values.size || "NO APLICA",
                quantity: Number(values.quantity),
                total: Number(values.total),
                observation: values.observation || "SIN OBSERVACIONES",
            };

            productList.push(newItem);

            await updateDoc(doc(querydb, "orders", order.key), {
                products: productList,
                saleAmount: Number(order.saleAmount) + Number(values.total),
                payable: (Number(order.saleAmount) + Number(values.total) + Number(order.shippingAmount)) - Number(order.advanceDelivery),
            });

            updateItems(order);
            updateOrder();

            logUserAction(querydb, auth, "ADD_ITEM", order.serial, newItem.sku, {
                brand: values.brand.toUpperCase(),
                category: values.category.toUpperCase(),
                color: values.color.toUpperCase(),
                model: values.model.toUpperCase(),
                sku: values.model.toUpperCase(),
                size: values.size || "NO APLICA",
                quantity: Number(values.quantity),
                total: Number(values.total),
                observation: values.observation || "SIN OBSERVACIONES",
            }, APP_VERSION);
            form.resetFields();
            message.success(`Producto insertado en orden ${order.serial} exitosmente`);
            setIsOpen(false);
            itemsViewable(false);
        } catch (error) {
            console.log(error);
        }
    }

    const handleSize = async (values) => {

        const categorySize = checkCategory(values.category);

        await checkValueFirebase(querydb, "sizes", "type", categorySize, "data").then((res) => {
            setSizes(mapDocs(res));
        })
    }

    return (
        <Modal
            open={isOpen}
            onOk={() => setIsOpen(false)}
            footer={null}
            title="Adicionar producto"
            onCancel={() => setIsOpen(false)}
        >
            <Form
                name="basic"
                form={form}
                layout="vertical"
                onFinish={handleSignUp}
                onValuesChange={handleSize}
                autoComplete="off"
                requiredMark
            >
                <Row gutter={16}>
                    <Col xs={24} sm={24} md={24} lg={12}>
                        {/* brand */}
                        <Form.Item
                            name="brand"
                            label="Marca"
                            rules={[
                                {
                                    required: true,
                                    message: "Debe ingresar un marca",
                                    type: "string",
                                }
                            ]}
                        >
                            <Select>
                                {brands && brands.length ?
                                    brands.filter(brand => brand.status !== false).map((brand, i) => <Option value={brand.name} key={i}>{brand.name}</Option>)
                                    : null
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12}>
                        {/* category */}
                        <Form.Item
                            name="category"
                            label="Categoria"
                            rules={[
                                {
                                    required: true,
                                    message: "Debe ingresar una categoria",
                                    type: "string",
                                },
                            ]}
                        >
                            <Select>
                                {categories && categories.length ?
                                    categories.map((category, i) => <Option value={category.name} key={i}>{category.name}</Option>)
                                    : null
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col xs={24} sm={24} md={24} lg={12}>
                        {/* color */}
                        <Form.Item
                            name="color"
                            label="Color"
                            rules={[
                                {
                                    required: true,
                                    message: "Debe ingresar un color",
                                    type: "string",
                                },
                                {
                                    validator: validateColor,
                                }
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12}>
                        {/* model */}
                        <Form.Item
                            name="model"
                            label="Modelo"
                            rules={[
                                {
                                    required: true,
                                    message: "Debe ingresar el modelo",
                                    type: "string",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col xs={24} sm={24} md={24} lg={12}>
                        {/* sku */}
                        <Form.Item
                            label="SKU"
                            name="sku"
                            rules={[
                                {
                                    required: true,
                                    message: "Debe ingresar sku",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    {form.getFieldValue('category') && categories.find(category => category.name === form.getFieldValue('category')).size !== "NO APLICA" ?
                        <Col span={12}>
                            <Form.Item
                                name="size"
                                label="Talla"
                                rules={[
                                    {
                                        required: true,
                                    },
                                ]}>
                                <Select placeholder="seleccione una opcion">
                                    {sizes && sizes?.map((size, i) => {
                                        return <Option
                                            key={i}
                                            value={size.size}
                                            name={size.size}
                                            label={size.size}
                                        >
                                            {size.size}
                                        </Option>
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                        : null}
                </Row>
                <Row gutter={16}>
                    <Col xs={24} sm={24} md={24} lg={12}>
                        <Form.Item
                            name="quantity"
                            label="Cantidad"
                            rules={[
                                {
                                    required: true,
                                    message: "Debe ingresar cantidad"
                                },
                                {
                                    validator: validateQty
                                }
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12}>
                        <Form.Item
                            name="total"
                            label="Total"
                            rules={[
                                {
                                    required: true,
                                    message: "Debe ingresar precio total"
                                },
                                {
                                    validator: validatePrice,
                                }
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col xs={24} sm={24} md={24} lg={24}>
                        <Form.Item
                            name="observation"
                            label="Observaciones"
                            rules={[
                                {
                                    required: false,
                                }
                            ]}
                        >
                            <TextArea rows={4} />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item className="footer-btn-modal">
                    <Button onClick={() => setIsOpen(false)} size="large">
                        Cancelar
                    </Button>
                    <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        className="button-right"
                    >
                        Registrar
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
}